Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconDeleteData: "data:image/svg+xml,%3csvg width='24' height='18' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M7.585 2l-6.29 6.29a1.003 1.003 0 000 1.42L7.585 16M12 6l6 6M18 6l-6 6'/%3e%3cpath d='M7.605 2l14.397-.01c.519 0 1.003.513 1.003 1.013L23 14.998c0 .538-.464 1.01-.995 1.01L7.556 16'/%3e%3c/g%3e%3c/svg%3e",
  iconDeleteWidth: 24,
  iconDeleteHeight: 18
};